import Vue from 'vue';
import axios from 'axios';
import {
  LMap, LTileLayer, LMarker, LPolyline, LPolygon, LLayerGroup,
  LTooltip, LPopup, LControlZoom, LControlAttribution, LControlScale,
  LControlLayers, LGeoJson, LIcon } from 'vue2-leaflet';
import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { latLngBounds } from 'leaflet';
import L from "leaflet";
import { latLng } from "leaflet";
import { v4 as uuidv4 } from 'uuid';

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-polyline', LPolyline);

export default {
  name: 'CaptureElement',
  props: {
    dataObj: {
      type: Object,
      required: true
    },
    closeFunc: {
      type: Function,
      required: true
    }

  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPolyline,
    LPolygon,
    LLayerGroup,
    LTooltip,
    LPopup,
    LControlZoom,
    LControlAttribution,
    LControlScale,
    LControlLayers,
    LIcon,
    LGeoJson,
    CustomFieldsComp: require('../../components/customFields.vue').default,
  },
  
  data() {
    return {
      isElementCaptured: false,
      gisSettings: null,
      tileProviders: [],
      mapProvider: -1,
      mapDiv: null,
      center: { lat: -25.47448, lng: 30.97033 },
      opacity: 0.6,
      token: 'your token if using mapbox',
      mapOptions: {
        //zoomControl: false,
        attributionControl: false,
        zoomSnap: true,
      },
      zoom: 17,
      minZoom: 1,
      maxZoom: 1,
      attributionPrefix: 'Vue2Leaflet',
      imperial: false,
      Positions: ['topleft', 'topright', 'bottomleft', 'bottomright'],
      markers: [],
      polylines: [],
      polygons: [],
      polygonColour: "#ff0000",
      geometryType: -1,
      iconSize: [40, 40],
      icon: L.icon({
        iconUrl: require('@/assets/images/map/teal-dot.svg'),
        iconSize: [40, 40],
      }),
      layers: [],
      fieldElementType: {},
      geoJson: [],
      styleProperties: {
        //color: '#ffe40c',
        //weight: 4
        color: 'orange',
        weight: 3
      },
      isAddMarkersEnabled: true,
      description: '',
      customFields: {},
      capturedElement: {
        elementType: {},
        elementId: ''
      },
    };
  },
  mounted() {
    this.chooseMapProvider();
    this.displayIcon();
    this.getCoordinates(true);
  },
  created() {
    this.dataObj.elementId = 22;
    //error trap
    if (this.dataObj.elementTypeId == null || this.dataObj.elementTypeId < 0)
      this.cancel();

    this.GetFieldElementType();

    this.$nextTick(() => {
      this.mapDiv = this.$refs.mapContainer.mapObject;
    });

    //console.log("capture element dataObj", this.dataObj)
  },

  methods: {
    displayIcon() {
      type D = Icon.Default & {
        _getIconUrl?: string;
      };

      delete (Icon.Default.prototype as D)._getIconUrl;

      Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/map/blue-dot.svg'),
        iconUrl: require('@/assets/images/map/blue-dot.svg'),
        shadowUrl: require('@/assets/images/map/blue-dot.svg'),
        iconSize: this.iconSize,
      });

      this.drawPolyline();
    },
    mapChanged() {
      this.getMapElements();
    },
    chooseMapProvider() {
      if (this.dataObj.gisSettings.mapProvider == 3) {
        this.tileProviders.push({
          name: 'GoogleMaps',
          visible: false,
          url: 'http://{s}.google.com/vt?lyrs=m&x={x}&y={y}&z={z}',
          minZoom: 1, //TBI 14
          subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
        });
      } else { //if (this.dataObj.gisSettings.mapProvider == 0) {
        this.tileProviders = [
          {
            name: 'OpenStreetMap',
            visible: true,
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          },
        ];
      } 
    },
    getCoordinates(centerMap) {
      navigator.geolocation.getCurrentPosition((position) => {
        var lat = position.coords.latitude;
        var lng = position.coords.longitude;
        if (lat != null && lng != null) {
          this.dataObj.latitude = lat;
          this.dataObj.longitude = lng;

          if (centerMap == true)
            this.center = { lat: lat, lng: lng };
        }
      });
    },
    getCenterOfMapCoordinates() {
      return this.mapDiv.getCenter();
    },

    addMarker(event) {
      if (this.isAddMarkersEnabled == false)
        return;

      let newMarker = {
        isDraggable: true,
        visible: true,
        id: uuidv4(),
        position: {
          lat: event.latlng.lat,
          lng: event.latlng.lng
        },
        icon: this.icon,
      };

      if (this.geometryType == 1) {
        this.markers.push(newMarker);
        this.drawPolyline();
      }
      else if (this.geometryType == 2) {
        this.markers.push(newMarker);
        this.drawPolygon();
      }
      else { // single selection
        this.markers.length = 0;
        this.markers.push(newMarker);
      }
    },
    drawPolyline() {
      var polyCoord = [];
      this.polylines = [];
    
      this.markers.forEach(m => {
        polyCoord.push(m.position);
      });

      var poly = [{
        points: polyCoord,
        visible: true,
        id: uuidv4(),
      }]

      this.polylines = poly;
    },
    drawPolygon() {
      var polyCoord = [];
      this.polygons = [];

      this.markers.forEach(m => {
        polyCoord.push(m.position);
      });

      var poly = [{
        latlngs: polyCoord,
        id: uuidv4(),
        color: this.polygonColour,
      }];

      this.polygons = poly;
    },
    deleteMarker(index) {
      if (this.isAddMarkersEnabled == false)
        return;

      this.markers.splice(index, 1);

      if (this.geometryType == 1)
        this.drawPolyline();
      else if (this.geometryType == 2)
        this.drawPolygon();
    },
    markerMoved(marker) {    
      this.markers.forEach(m => {
        if (m.id == marker.id)
          m = marker;
      });

      if (this.geometryType == 1)
        this.drawPolyline();
      else if (this.geometryType == 2)
        this.drawPolygon();
    },

    GetFieldElementType() {
      axios.get('/Element/GetFieldElementType?elementTypeId=' + this.dataObj.elementTypeId)
        .then(resp => {
          //console.log("resp", resp);
          if (resp.data == '' || resp.data == null) {
            this.close(true);
          } else {
            this.fieldElementType = resp.data;

            //geometryTypes: None = -1, Point = 0, Line = 1, Area = 2,
            this.geometryType = resp.data.geometryType; //TBI
            if (this.geometryType == -1)
              this.isAddMarkersEnabled = false;
          }
        })
        .catch(err => {
          this.$alertMsg(err.message);
        })
        .finally(() => this.getMapElements());
    },
    getMapElements() {
      this.geoJson = [];
      this.layers = [];
      this.GetElementsByLngLat(this.fieldElementType.typeId);
      this.GetElementsByLngLat(this.dataObj.elementTypeId);
    },
    GetElementsByLngLat(elementTypeId) {
      //error trap
      if (elementTypeId < 0)
        return

      let coord = this.getCenterOfMapCoordinates();
      let param = 'elementTypeId=' + elementTypeId;
      if (coord != [])
        param = param + '&longitude=' + coord.lng + '&latitude=' + coord.lat;

      axios.get('/Element/GetElementsByLngLat?' + param)
        .then(resp => {
          if (resp.data != '' || resp.data != null) {
            this.layers = resp.data.layers;
            
            if (this.layers.length > 0) {
              resp.data.layers.forEach(p => {
                this.geoJson.push(p.geoJson);
              });
            }

          } 
        })
        .catch(err => {
          this.$alertMsg(err.message);
        });
    },
    GetCustomFields() {
      axios.get('/Element/GetCustomFields?elementTypeId=' + this.fieldElementType.typeId)
        .then(resp => {
          //console.log("resp", resp, this.element);
          this.customFields['items'] = resp.data;
          this.isElementCaptured = true;
        })
        .catch(err => {
          this.$alertMsg(err.message);
        });
    },
    saveCustomFields() {
      let points = [];

      this.markers.forEach(m => {
        points.push({
          X: m.position.lng,
          Y: m.position.lat
        });
      })

      let param = {
        elementTypeId: this.fieldElementType.typeId,
        CustomFieldValues: this.customFields.items,
        Geometry: points
        }

      axios.post('/Element/Create', param)
        .then(resp => {
          //console.log("resp", resp, this.element);
          if (resp.data != null)
            this.capturedElement =
            {
              elementType: this.fieldElementType,
              elementId: resp.data
            }
          this.close(false,this.capturedElement);
        })
        .catch(err => {
          this.$alertMsg(err.message);
        });
    },
    save() {
      //error traps
      let errorFlag = false;
      if (this.geometryType == 0 && this.markers.length == 0)
        errorFlag = true;

      if (this.geometryType > 0 && this.markers.length <= 1)
        errorFlag = true;

      if (errorFlag) {
        this.$alertMsg(this.$t('CaptureElement.PointSaveError'),3);
        return;
      }

      if (!this.isElementCaptured)
        this.GetCustomFields();
      else {
        this.saveCustomFields();
      }
    },
    close(disableCapture) {
      this.closeFunc(disableCapture, this.capturedElement);
    },
    cancel() {
      this.resetCapturedElement();
      this.close(false);
    },
    resetCapturedElement() {
      this.capturedElement = {
        elementType: null,
        elementId: ''
      }
    }
  },
};


